import React, { useEffect, useState } from 'react';

import { useCustomDispatch, useCustomLocation } from '../../hooks';
import { useAuthSelector } from '../../services/selectors/authSelector';
import { SendMessageNotification } from '../../components/chat/helper';
import { authOTPVerified } from '../../storage/authToken';
import * as routeNames from '../../routes/routeName';

import { NewMessageNotification } from '../../components/common/AllConfirmationMessages';
import { chatNotificationAudio } from '../../assets/audio';


const MessageNotifications = () => {

    const { pharmacyId, driverID } = useAuthSelector()

    const location = useCustomLocation();
    const dispatch = useCustomDispatch();

    const [showNotification, setShowNotification] = useState(false)
    const [showData, setShowData] = useState(null)
    const isOtpVerified = Number(authOTPVerified()) === 1;
    const isOtpVerificationScreen = location.pathname === routeNames.verify_otp;
    const shouldLoadChatAudio = isOtpVerified && !isOtpVerificationScreen && pharmacyId && driverID;

    const playMessageSound = () => {
        const audio = document.getElementById('notification_audio');
        audio?.play().catch(() => {});
    }

    useEffect(() => {
        if (!isOtpVerified || isOtpVerificationScreen || !pharmacyId || !driverID) {
            return undefined;
        }

        // Previously this created a throwaway Ably client purely to read
        // .connection.state (leaking a connection on every mount) and only closed the
        // real subscription if that unrelated client happened to be connected.
        // SendMessageNotification now returns a { close } handle over the shared client.
        const subscription = SendMessageNotification(pharmacyId, driverID, dispatch, location, setShowData, setShowNotification, playMessageSound)

        return () => {
            subscription?.close();
        };

    }, [dispatch, driverID, isOtpVerified, isOtpVerificationScreen, location, pharmacyId]);

    return (
        <>
            <div className={`fixed w-full left-0 duration-500 ${showNotification ? 'top-0' : '-top-full'}`}>
                <NewMessageNotification
                    message={`${showData?.title} sent you a message`}
                    data={showData}
                    setShowToast={() => setShowNotification(false)}
                />
            </div>

            {shouldLoadChatAudio && (
                <audio id="notification_audio" preload="none">
                    <source src={chatNotificationAudio} type="audio/mpeg" />
                </audio>
            )}
        </>
    );
}

export default MessageNotifications
